<template lang="pug">
segment.actor-highlights(
    v-if="items.length"
    v-bind:title="title")
    slick-slides.actor-slides(
        ref="SlickSlides"
        v-bind:options="slickOptions || slickOptions2"
        v-bind:items="items")
        template(#slide-card="slotScope")
            div.columns(
                v-if="slotScope.item")
                //- Actor ingress image
                actor-card.column.is-6(
                    v-bind:item="slotScope.item"
                    v-bind:image-as-background="true")

                //- Actor presentation BodyHtml
                div.actor-body.column.is-6(
                    v-if="showBody && slotScope.item.BodyHtml && slotScope.item.BodyHtml.length")

                    article(v-html="slotScope.item.BodyHtml")
                    //- "show more" only when body text is long enough
                    button.btn(
                        v-if="slotScope.item.BodyHtml && slotScope.item.BodyHtml.length > 50")
                        router-link(
                            v-bind:to="getRoute(slotScope.item, {section: 'info-artworks'}, 'Actor')"
                            v-bind:title="slotScope.item.Name"
                        ) {{ $t('common.readMore') }}

                //- show CoverImage artwork, .is-6 for portraits and .is-12 for landscapes
                div.actor-body-artworks.column(
                    v-if="showArtworks && slotScope.item.CoverImageInfo"
                    v-bind:class="slotScope.item.CoverImageInfo.Width > slotScope.item.CoverImageInfo.Height ? 'is-12' : 'is-6'")
                    artwork-card(
                        v-bind:item="slotScope.item"
                        v-bind:resolution="{x: 500}")

                slot

</template>

<script>
import SearchMixin from '@/components/Base/SearchMixin';
import HyperlinkMixin from '@/components/Base/HyperlinkMixin';

export default {
    name: 'actor-highlights',

    props: {
        items: {            type: Array[Object] },
        title: {            type: String },
        showBody: {         type: Boolean, default: true },
        showArtworks: {     type: Boolean, default: false },
        slickOptions: {     type: Object }
    },

    mixins: [ SearchMixin, HyperlinkMixin ],

    data: function () {
        return {
            slickOptions2: {
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 1,
                arrows: true,
                variableWidth: false,
                adaptiveHeight: true,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
            error: null
        };
    },

    watch: {
        items: function () {
            this.init();
        }
    },

    methods: {
        init: function () {
            this.$refs.SlickSlides && this.$refs.SlickSlides.reSlick();
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.actor-highlights {
    width: 100%;
    .columns {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        @media (max-width: 850px) {
            justify-content: center;
            &.actor-query-options {
                justify-content: left;
            }
        }
        @media screen and (max-width: $breakpoint-mobile - 1) {
            flex-direction: column !important;
        }
    }
    .slick-track {
        min-height: unset;
        // without this margin, some content might get clipped
        margin-bottom: 1.5rem;
    }
    .actor-slides {
        display: flex;
        flex-direction: column;
        margin-top: 0;
        padding: 0;
        .slick-slide:nth-child(odd) {
            .columns {
                flex-direction: row-reverse;
            }
        }
        .slick-slide:nth-child(even) {
            .actor-body-artworks .card {
                margin-left: auto;
            }
        }
        .actor-card {
            margin-top: 0;
            text-align: center;
            .card-image {
                width: 180px !important;
                height: auto;
                margin: 0 auto !important;
                figure {
                    height: auto !important;
                }
                .image {
                    margin: 0 auto;
                }
            }
            .card-header-title {
                align-items: center;
                margin-top: 1.5rem;
                text-align: center;
                h2.title {
                    overflow: visible;
                    font-size: 1.25em;
                }
            }
            .social-actions {
                display: inline-flex;
                flex-direction: row !important;
                width: 100%;
                margin: 0.75rem auto 1rem 0;
                padding: 0;
                font-size: 0.8rem !important;
                .social-button-wrapper {
                    margin: 0 auto;
                }
                .do-heart {
                    margin-left: 0;
                    border-color: black;
                    border-width: 2px;
                }
                .do-follow span {
                    vertical-align: sub;
                }
            }
            .makers, .ingress-text {
                display: none;
            }
        }
        .actor-body {
            margin-bottom: 1.5rem;
            article {
                // CSS fade!
                @include fade-read-more(400px);
            }
            .btn {
                height: 2rem;
                margin-top: 1.5rem;
                color: inherit;
                border: 0;
            }
        }
        .actor-body-artworks {
            &.is-6 {
                // stylelint-disable-next-line no-descending-specificity
                .card {
                    width: 280px !important;
                }
            }
            &.is-12 {
                width: 100%;
            }
        }
    }

    @media screen and (max-width: $breakpoint-mobile - 1) {
        .actor-body-artworks {
            .artwork-card {
                width: 100% !important;
                height: auto;
            }
        }
    }
}
</style>
